const reportWebVitals = () => {
  // Placeholder for web vitals reporting
  return null;
};

export default reportWebVitals;
